import { render, staticRenderFns } from "./level-progress.vue?vue&type=template&id=539ba8bc&scoped=true"
import script from "./level-progress.vue?vue&type=script&lang=js"
export * from "./level-progress.vue?vue&type=script&lang=js"
import style0 from "./level-progress.vue?vue&type=style&index=0&id=539ba8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ba8bc",
  null
  
)

export default component.exports